import { Checkbox, ICheckboxProps } from "@/eworkitComponents";

import { withFormikField } from "./withFormikField";

/**
 * @deprecated Use iris-based implementation instead.
 */
export const FormikCheckbox = withFormikField<ICheckboxProps>(Checkbox);
